import { render, staticRenderFns } from "./BaseUploadAttachment.vue?vue&type=template&id=685eab74&scoped=true"
import script from "./BaseUploadAttachment.vue?vue&type=script&lang=js"
export * from "./BaseUploadAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685eab74",
  null
  
)

export default component.exports